import { Route } from '@angular/router';
import {
  authRoutes,
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
  NOT_FOUND_ROUTE,
} from '@kuiper/ibusiness-core';
import { landingRoutes } from './layout/landing.routes';

export const appRoutes: Route[] = [
  ...landingRoutes,
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: NOT_FOUND_ROUTE,
    loadComponent: () =>
      import('@kuiper/ibusiness-core').then(c => c.NotFoundComponent),
  },
  {
    path: AUTH_ROUTES.RESET_PASSWORD,
    loadComponent: () =>
      import('@kuiper/ibusiness-core').then(c => c.ResetPasswordComponent),
  },
  {
    path: AUTH_MAIN_ROUTE,
    loadComponent: () =>
      import('@kuiper/ibusiness-core').then(c => c.AuthComponent),
    children: [...authRoutes],
  },
  {
    path: '**',
    redirectTo: '/' + NOT_FOUND_ROUTE,
  },
];
